import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { OkOrNoFlug } from "../../assets/data/Constants";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkStepper from "../../components/atoms/TkStepper";
import TkConfirmItem from "../../components/molecules/TkConfirmItem";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkButton from "../../components/atoms/TkButton";
import { TkGetCodeList } from "../../utils/TkGetCode";
import { httpAPI_BUS007, httpAPI_FAC043 } from "./api/request";
import { InfoManual, itemList, stepper } from "./parts";
import "./_style.scss";
import { IJob_11Props } from "../../type/contextType/businessContext/IJob_11";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

/**
 * SCRC080002 掛金納付対象職員届提出時の事前確認
 * 掛金届提出の事前確認をする。
 * @return SCRC080002
 */
const SCRC080002 = () => {
  const navigate = useNavigate();
  // 認証情報
  const { state, setState } = useContext(GlobalContext);
  // 持回情報
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const initialCheckObj = businessState?.job_11
    ? {
        confirmation1: businessState?.job_11?.confirmation1 || false,
        confirmation2: businessState?.job_11?.confirmation2 || false,
        confirmation3: businessState?.job_11?.confirmation3 || false,
        confirmation4: businessState?.job_11?.confirmation4 || false,
        confirmation5: businessState?.job_11?.confirmation5 || false,
        confirmation6: businessState?.job_11?.confirmation6 || false,
        confirmation7: businessState?.job_11?.confirmation7 || false,
        confirmation8: businessState?.job_11?.confirmation8 || false,
      }
    : {};
  const confirm4Active =
    businessState?.job_11?.confirmFourActivityFlg === "0" ? false : true;

  const checkObjRef = useRef<{ [key: number]: boolean }>(initialCheckObj);
  const checkObj = checkObjRef.current;
  const setCheckObj = (value: any) => {
    checkObjRef.current = value;
  };
  const [funcObj, setFuncObj] = useState<any>({});
  const [checkedAll, setCheckedAll] = useState(false);
  const [openWarning, setOpenWarning] = useState(false);

  useEffect(() => {
    setBusinessState({
      common: { ...businessState.common, businessType: "JOB-11" },
      job_11: businessState.job_11,
    });

    if (businessState?.job_11) {
      let tempObj: any = {};
      let temFuncObj: any = {};
      let temCheckObj: any = {};
      for (let i = 1; i <= 8; i++) {
        const confirmationKey =
          `confirmation${i}` as keyof typeof businessState.job_11;
        const confirmationValue = businessState.job_11[confirmationKey];

        if (
          typeof confirmationValue === "boolean" &&
          confirmationValue !== undefined &&
          confirmationValue !== null
        ) {
          temFuncObj[`confirmation${i}`] = !confirmationValue;
          temCheckObj[`confirmation${i}`] = confirmationValue;
          tempObj[`confirmation${i}`] = confirmationValue;
        }
      }

      setFuncObj({
        ...funcObj,
        ...temFuncObj,
      });

      setCheckObj({
        ...checkObj,
        ...temCheckObj,
      });

      const tempObjArr = Object.values(tempObj);

      if (
        tempObjArr.length === (confirm4Active ? 8 : 7) &&
        tempObjArr.every((item) => item)
      ) {
        setCheckedAll(true);
      } else {
        setCheckedAll(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e: any, number: any) => {
    let yesFlg = e === OkOrNoFlug["はい"];
    const tempObj = {
      ...checkObj,
      [`confirmation${number}`]: yesFlg ? true : false,
    };
    setCheckObj({
      ...checkObj,
      [`confirmation${number}`]: yesFlg ? true : false,
    });
    setFuncObj({
      ...funcObj,
      [`confirmation${number}`]: !yesFlg ? true : false,
    });

    const falseCount = Object.values(tempObj).filter(
      (value) => value === false
    ).length;

    if (
      Object.values(tempObj).length === 8 &&
      Object.values(tempObj).every((item) => item)
    ) {
      setCheckedAll(true);
    } else {
      if (falseCount === 1 && !confirm4Active) {
        setCheckedAll(true);
      } else {
        setCheckedAll(false);
      }
    }

    setBusinessState({
      ...businessState,
      job_11: {
        ...businessState.job_11,
        [`confirmation${number}`]: yesFlg,
      },
    });
  };

  const handleConfimButtonClicked = (page: any, number: any) => {
    setBusinessState({
      ...businessState,
      common: { ...businessState.common, businessType: "JOB-11" },
    });
    navigate(page, { state: { check: number } });
  };

  // 変更ボタンクリック
  const handleFunctionButtonClicked = (businessType: any, funcNavi: string) => {
    setBusinessState({
      ...businessState,
      common: { ...businessState.common, businessType: businessType },
    });
    navigate(funcNavi);
  };

  const handleConfirmClick = async () => {
    // 廃止済み施設職員有無および未提出申請有無チェックAPI 呼び出し
    try {
      const res = await httpAPI_BUS007({
        contractorNo: state.authInfo?.contractorNo,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRC080103");
      } else if (res.resultCd === "TKMSG_SVR0035W") {
        setState({
          ...state,
          errorMsgId: "",
        });
        setOpenWarning(true);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const onWarningOk = async () => {
    setOpenWarning(false);
    try {
      const res = await httpAPI_FAC043({
        contractorNo: state.authInfo?.contractorNo,
      });
      if (res.resultCd === "I0000") {
        navigate("/SCRC080103");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRC080002PageForTest" className="SCRC080002">
      <TkStepper steps={stepper} activeStep={0} />

      <TkInfoManual rule={"<"}>{InfoManual}</TkInfoManual>

      {itemList.map((item, index) => {
        let radioCecked: string | undefined;
        let disabled: boolean | undefined;
        const itemNumber = `confirmation${item.number}`;
        const bussinessStateValue: any =
          businessState?.job_11?.[itemNumber as keyof IJob_11Props];

        if (bussinessStateValue !== undefined && bussinessStateValue !== null) {
          if (bussinessStateValue) {
            radioCecked = "1";
          } else {
            radioCecked = "0";
          }
        }

        if (!confirm4Active && item.number === 4) {
          disabled = true;
        } else {
          disabled = false;
        }

        return (
          <React.Fragment key={index}>
            {item.type === "lineTitle" && (
              <Box className="lineTitleTextLabel">{item.lineTitle}</Box>
            )}
            {item.type === "item" && (
              <Box className="confirmItemLayout">
                <TkConfirmItem
                  radioPropsList={TkGetCodeList(OkOrNoFlug)}
                  confimButtonContext="内容を確認する"
                  functionButtonContext={item.funcButton}
                  onChange={(e: any) => handleChange(e, item.number)}
                  onConfimButtonClicked={() =>
                    handleConfimButtonClicked(item.confirmNavi, item.number)
                  }
                  onFunctionButtonClicked={() =>
                    handleFunctionButtonClicked(
                      item.businessType,
                      `${item.funcNavi}`
                    )
                  }
                  checked={radioCecked}
                  isShowFunctionButton={funcObj[`confirmation${item.number}`]}
                  helpIcon={item.helpIcon}
                  helpText={item.helpText}
                  isGuideText={funcObj[`confirmation${item.number}`]}
                  guideText={item.guideText}
                  disabled={disabled}
                >
                  {item.title}
                </TkConfirmItem>
              </Box>
            )}
          </React.Fragment>
        );
      })}

      <Box className="tkButtonBox">
        <TkBackButton />
        <TkButton onClick={handleConfirmClick} disabled={!checkedAll}>
          確認しました
        </TkButton>
      </Box>
      <TkMessageDialog
        open={openWarning}
        onOky={onWarningOk}
        onCancel={() => setOpenWarning(false)}
        title="確認ダイアログ"
        contextText={TkPropertyMessageGet("TKMSG_SVR0035W")}
        okText="はい"
        cancelText="いいえ"
      />
    </Box>
  );
};

export default SCRC080002;
